import React from 'react';
import { Col, Row, Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from '../tableReports/style.module.scss';

const HolidayTable = ({ data }) => {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  const columns = [
    {
      title: t(''),
      dataIndex: 'day',
      key: 'day',
      fixed: 'left',
      className: styles.columnGroupFirst,
    },
    {
      title: t('Fatturato Netto (€)'),
      dataIndex: 'taxable',
      key: 'taxable',
      className: styles.columnGroupFirst,
    },
    {
      title: t('Fatturato Lordo (€)'),
      dataIndex: 'taxable_vat',
      key: 'taxable_vat',
      className: styles.columnGroupFirst,
    },
    {
      title: t('Scontrini'),
      dataIndex: 'receipts',
      key: 'receipts',
      className: styles.columnGroupFirst,
    },
    {
      title: t('Pezzi Venduti'),
      dataIndex: 'pieces',
      key: 'pieces',
      className: styles.columnGroupFirst,
    },
    {
      title: t('Fatturato Netto (€)'),
      dataIndex: 'taxable_file',
      key: 'taxable_file',
      className: styles.columnGroupSecond,
    },
    {
      title: t('Fatturato Lordo (€)'),
      dataIndex: 'taxable_vat_file',
      key: 'taxable_vat_file',
      className: styles.columnGroupSecond,
    },
    {
      title: t('Scontrini'),
      dataIndex: 'receipts_file',
      key: 'receipts_file',
      className: styles.columnGroupSecond,
    },
    {
      title: t('Pezzi Venduti'),
      dataIndex: 'pieces_file',
      key: 'pieces_file',
      className: styles.columnGroupSecond,
    },
    {
      title: t('Fatturato Netto (€)'),
      dataIndex: 'taxable_delta',
      key: 'taxable_delta',
      className: styles.columnGroupThird,
    },
    {
      title: t('Fatturato Lordo (€)'),
      dataIndex: 'taxable_vat_delta',
      key: 'taxable_vat_delta',
      className: styles.columnGroupThird,
    },
    {
      title: t('Scontrini'),
      dataIndex: 'receipts_delta',
      key: 'variance_receipts',
      className: styles.columnGroupThird,
    },
    {
      title: t('Pezzi Venduti'),
      dataIndex: 'pieces_delta',
      key: 'pieces_delta',
      className: styles.columnGroupThird,
    },
  ];
  

  const formattedData = data.rows.map((row, index) => ({
    key: index,
    ...row,
  }));


  return (
    <Row gutter={24} style={{ marginBottom: '24px' }}>
         <Col span={24}>
        <Typography.Title level={3}>{t('Giorni chiusi con rapporto inviato')}</Typography.Title>
      </Col>
      <Col span={24} style={{ padding: '12px' }}>
        <Table
          columns={columns}
          dataSource={[...formattedData]} 
          pagination={false}
          scroll={{ x: 1200, y: 400 }}
          bordered
        />
      </Col>
    </Row>
  );
};

export default HolidayTable;
